"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blangOperators = exports.blangVariables = void 0;
// BLANG predefined variables for autocompletion
exports.blangVariables = [
    // Variables representing API input
    { label: '$title', type: 'variable', info: 'The title of the item' },
    { label: '$body', type: 'variable', info: 'The body/description of the item' },
    { label: '$text', type: 'variable', info: 'Concatenation of the title and body of an item, with a line break separating them' },
    { label: '$phoneNumber', type: 'variable', info: 'First phone number of the user posting the item' },
    { label: '$categoryName', type: 'variable', info: 'The category of the item' },
    { label: '$categoryId', type: 'variable', info: 'The category ID of the item' },
    { label: '$price', type: 'variable', info: 'The price of the item' },
    { label: '$currency', type: 'variable', info: 'ISO 4217 currency code' },
    { label: '$type', type: 'variable', info: 'Type of the item' },
    { label: '$userId', type: 'variable', info: 'Id of the user posting the item' },
    { label: '$userName', type: 'variable', info: 'Username of the user posting the item' },
    { label: '$city', type: 'variable', info: 'The city name' },
    { label: '$postalCode', type: 'variable', info: 'Postal (zip) code' },
    { label: '$region', type: 'variable', info: 'Region' },
    { label: '$countryCode', type: 'variable', info: 'Two-letter country code (ISO 3166-1 alpha-2)' },
    { label: '$ip', type: 'variable', info: 'IP address of the user posting the ad' },
    { label: '$status', type: 'variable', info: 'Status of the item in your system' },
    { label: '$images.count', type: 'variable', info: 'Number of images that the item contains' },
    {
        label: '$images.failCount',
        type: 'variable',
        info: "Number of item images that failed to be retrieved from the specified URL and therefore couldn't be processed",
    },
    { label: '$videos.count', type: 'variable', info: 'Number of videos that the item contains' },
    {
        label: '$images.fingerprint',
        type: 'variable',
        info: 'Image fingerprint (phash) calculated by Implio to identify and compare images between each other.',
    },
    // Variables representing user's moderation history
    { label: '$user.itemCount', type: 'variable', info: 'Number of items seen in Implio for that user to date' },
    {
        label: '$user.itemCount.1minute',
        type: 'variable',
        info: 'Number of items seen in Implio for that user over the past minute',
    },
    { label: '$user.itemCount.1hour', type: 'variable', info: 'Number of items seen in Implio for that user over the past hour' },
    { label: '$user.itemCount.1day', type: 'variable', info: 'Number of items seen in Implio for that user over the past day' },
    { label: '$user.itemCount.1week', type: 'variable', info: 'Number of items seen in Implio for that user over the past week' },
    { label: '$user.itemCount.1month', type: 'variable', info: 'Number of items seen in Implio for that user over the past month' },
    { label: '$user.itemCount.1year', type: 'variable', info: 'Number of items seen in Implio for that user over the past year' },
    {
        label: '$user.decisionCount',
        type: 'variable',
        info: 'Number of items with an Approved or Refused decision for that user to date',
    },
    { label: '$user.noDecisionCount', type: 'variable', info: 'Number of items without a decision for that user to date' },
    { label: '$user.approvedCount', type: 'variable', info: 'Number of Approved decisions for that user to date' },
    { label: '$user.refusedCount', type: 'variable', info: 'Number of Refused decisions for that user to date' },
    {
        label: '$user.approvedPercentage',
        type: 'variable',
        info: 'Percentage of Approved items over decision count for that user to date',
    },
    {
        label: '$user.refusedPercentage',
        type: 'variable',
        info: 'Percentage of Refused items over decision count for that user to date',
    },
    { label: '$user.approvedStreak', type: 'variable', info: 'Number of items last Approved in a row for that user to date' },
    { label: '$user.refusedStreak', type: 'variable', info: 'Number of items last Refused in a row for that user to date' },
    // Variables augmented from input
    {
        label: '$geoCity',
        type: 'variable',
        info: "Name of the city (in English) associated with the user's geolocation at the time of posting",
    },
    {
        label: '$geoContinent',
        type: 'variable',
        info: "Name of the continent (in English) associated with the user's geolocation at the time of posting",
    },
    {
        label: '$geoCountry',
        type: 'variable',
        info: "Name of the country (in English) associated with the user's geolocation at the time of posting",
    },
    {
        label: '$geoCountryCode',
        type: 'variable',
        info: "Two-letter country code (ISO 3166-1 alpha-2) associated with the user's geolocation at the time of posting",
    },
    {
        label: '$geoPostalCode',
        type: 'variable',
        info: "Postal code associated with the user's geolocation at the time of posting",
    },
    { label: '$user.agent.device.type', type: 'variable', info: 'Type of device' },
    { label: '$user.agent.device.model', type: 'variable', info: 'Device model' },
    { label: '$user.agent.device.brand', type: 'variable', info: 'Device brand' },
    { label: '$user.agent.client.name', type: 'variable', info: 'Client (browser or app) name' },
    { label: '$user.agent.os.family', type: 'variable', info: 'Operating system family' },
    { label: '$user.agent.os.version', type: 'variable', info: 'Operating system version' },
    { label: '$user.agent.cpu.architecture', type: 'variable', info: 'CPU architecture' },
    // Deduplication variables
    {
        label: '$numberOfDuplicates',
        type: 'variable',
        info: 'Number of text (title + body) duplicates across the entire Implio team',
    },
    {
        label: '$images[N].duplicateCount',
        type: 'variable',
        info: 'Number of image duplicates for image N across the entire Implio team',
    },
    {
        label: '$images.duplicateCount',
        type: 'variable',
        info: 'Combined number of image duplicates for all images in the item, across the entire Implio team',
    },
    // Text Vision (AI) models variables https://implio.helpjuice.com/18062-automation/text-vision-ai-features?from_search=192761053
    // Natural Language Detection
    {
        label: '$text.languageDetected',
        type: 'variable',
        info: 'Language in which the text is written (automatically detected).',
    },
    {
        label: '$text.languageExpected',
        type: 'variable',
        info: 'Value of the content.languageExpected API input field.',
    },
    // Toxic Language Detection
    {
        label: '$text.blasphemyCount',
        type: 'variable',
        info: 'Number of blasphemy terms detected in the text.',
    },
    {
        label: '$text.badWordCount',
        type: 'variable',
        info: 'Number of bad words detected in the text.',
    },
    {
        label: '$text.sexualTermCount',
        type: 'variable',
        info: 'Number of sexual terms detected in the text.',
    },
    {
        label: '$text.violenceTermCount',
        type: 'variable',
        info: 'Number of terms related to violence detected in the text.',
    },
    {
        label: '$text.extremismTermCount',
        type: 'variable',
        info: 'Number of terms related to extremism detected in the text.',
    },
    {
        label: '$text.racismTermCount',
        type: 'variable',
        info: 'Number of terms related to racism detected in the text.',
    },
    { label: '$text.toxicTermCount', type: 'variable', info: 'Total number of toxic terms detected in the text.' },
    // Nonsense Detection
    {
        label: '$text.isNonsense',
        type: 'variable',
        info: 'Indicates whether the text is nonsensical (e.g., gibberish, excessive punctuation).',
    },
    // Weapons and Drugs Detection
    {
        label: '$text.weaponTermCount',
        type: 'variable',
        info: 'Number of terms related to weapons detected in the text.',
    },
    {
        label: '$text.drugTermCount',
        type: 'variable',
        info: 'Number of terms related to drugs detected in the text.',
    },
    // Contact Details Detection
    {
        label: '$text.hasUrl',
        type: 'variable',
        info: 'Indicates whether the text contains a URL.',
    },
    {
        label: '$text.hasEmail',
        type: 'variable',
        info: 'Indicates whether the text contains an email address.',
    },
    {
        label: '$text.hasPhoneNumber',
        type: 'variable',
        info: 'Indicates whether the text contains a phone number.',
    },
    {
        label: '$text.hasSocialMediaId',
        type: 'variable',
        info: 'Indicates whether the text contains a social media identifier.',
    },
    {
        label: '$text.hasFullName',
        type: 'variable',
        info: 'Indicates whether the text has any mention of a full name.',
    },
    {
        label: '$text.hasContactInfo',
        type: 'variable',
        info: 'Indicates whether the text contains some other form of contact information.',
    },
    {
        label: '$text.hasContactRequest',
        type: 'variable',
        info: 'Indicates whether the author asks other users for their contact information.',
    },
    // underage variables
    {
        label: '$text.underage14',
        type: 'variable',
        info: 'Indicates whether the author mentions he/she is younger than 14, or seeks someone under that age.',
    },
    {
        label: '$text.underage15',
        type: 'variable',
        info: 'Indicates whether the author mentions he/she is younger than 15, or seeks someone under that age.',
    },
    {
        label: '$text.underage16',
        type: 'variable',
        info: 'Indicates whether the author mentions he/she is younger than 16, or seeks someone under that age.',
    },
    {
        label: '$text.underage17',
        type: 'variable',
        info: 'Indicates whether the author mentions he/she is younger than 17, or seeks someone under that age.',
    },
    {
        label: '$text.underage18',
        type: 'variable',
        info: 'Indicates whether the author mentions he/she is younger than 18, or seeks someone under that age.',
    },
    {
        label: '$text.underage19',
        type: 'variable',
        info: 'Indicates whether the author mentions he/she is younger than 19, or seeks someone under that age.',
    },
    {
        label: '$text.underage20',
        type: 'variable',
        info: 'Indicates whether the author mentions he/she is younger than 20, or seeks someone under that age.',
    },
    {
        label: '$text.underage21',
        type: 'variable',
        info: 'Indicates whether the author mentions he/she is younger than 21, or seeks someone under that age.',
    },
    // Gender variables
    { label: '$text.gender', type: 'variable', info: 'Gender of the author, as stated by the author.' },
    { label: '$text.genderSeek', type: 'variable', info: 'Gender sought by the author, as stated by the author.' },
    // Relationship status variables
    {
        label: '$text.inARelationship',
        type: 'variable',
        info: 'Indicates whether the author mentions that he/she is in a relationship.',
    },
    {
        label: '$text.seekingCasualRelationship',
        type: 'variable',
        info: 'Indicates whether the author mentions he/she is seeking a casual relationship.',
    },
    // Romance scam
    { label: '$text.isRomanceScam', type: 'variable', info: 'Indicates whether text is a potential romance scam.' },
    // Subscription info
    {
        label: '$text.hasSubscriptionInfo',
        type: 'variable',
        info: 'Indicates whether the author refers to his/her subscription or member status on the service.',
    },
    // Optical Character Recognition variables
    {
        label: '$images[n].text.ocr',
        type: 'variable',
        info: 'Contains the characters recognized in image n.',
    },
    {
        label: '$images.text.ocr',
        type: 'variable',
        info: 'Contains the characters recognized in all images of the item.',
    },
    // Object count
    {
        label: '$images[n].<tag>.count',
        type: 'variable',
        info: 'Number of <tag> objects detected in image n.',
    },
    {
        label: '$images.<tag>.count',
        type: 'variable',
        info: 'Combined number of <tag> objects detected in all images of the item.',
    },
    // Object area
    {
        label: '$images[n].<tag>.area',
        type: 'variable',
        info: 'Proportion of image area represented by all <tag> objects in image n. For example, if image 0 contains two faces representing 10% and 5% of the image, then $images[0].face.area = 0.15',
    },
    {
        label: '$images[n].<tag>.minObjectArea',
        type: 'variable',
        info: 'Proportion of image area represented by the smallest <tag> object in image n. For example, with objects representing 10% and 5%, the value is 0.05',
    },
    {
        label: '$images[n].<tag>.maxObjectArea',
        type: 'variable',
        info: 'Proportion of image area represented by the largest <tag> object in image n. For example, with objects representing 10% and 5%, the value is 0.1',
    },
    {
        label: '$images.<tag>.area',
        type: 'variable',
        info: 'Average area represented by <tag> objects across all item images. If two images have faces covering 10% and 5%, value = 0.075',
    },
    {
        label: '$images.<tag>.minArea',
        type: 'variable',
        info: 'Minimum area represented by a <tag> object across all item images. If faces in two images are 10% and 5%, value = 0.05',
    },
    {
        label: '$images.<tag>.maxArea',
        type: 'variable',
        info: 'Maximum area represented by a <tag> object across all item images. If faces in two images are 10% and 5%, value = 0.1',
    },
];
//  BLANG operators for autocompletion
exports.blangOperators = [
    { label: 'CONTAINS', type: 'operator' },
    { label: 'NOT CONTAINS', type: 'operator' },
    { label: 'SIMILAR', type: 'operator' },
    { label: '<', type: 'operator' },
    { label: '>', type: 'operator' },
    { label: '<=', type: 'operator' },
    { label: '>=', type: 'operator' },
    { label: '!=', type: 'operator' },
    { label: 'EQUALS', type: 'operator' },
    { label: 'NOT EQUALS', type: 'operator' },
    { label: 'BETWEEN', type: 'operator' },
    { label: 'NOT BETWEEN', type: 'operator' },
    { label: 'LENGTH', type: 'operator' },
    { label: 'EXISTS', type: 'operator' },
    { label: 'NOT EXISTS', type: 'operator' },
    { label: 'AND', type: 'operator' },
    { label: 'OR', type: 'operator' },
    { label: 'NOT', type: 'operator' },
    { label: 'MATCH', type: 'operator' },
];
